module.exports = __webpack_public_path__ + "pstatic/img/footer_logo.cb0b31a6.png";